<template lang='pug'>
  v-card-text
    v-timeline(align-top dense)
      v-timeline-item(color="accent" small)
        v-row(class="pt-1")
          v-col(cols="6") Drag green controls to adjust character dimensions
          v-col
            v-img(src='/day6-workflow/editor-green-rings.svg' max-width='128')
      v-timeline-item(color="accent" small)
        v-row(class="pt-1")
          v-col(cols="6") Drag sliders to fine tune other sizes
          v-col
            v-img(src='/day6-workflow/editor-sliders.svg' max-width='128')
      v-timeline-item(color="accent" small)
        v-row(class="pt-1")
          v-col(cols="6") Double click the head, neck, body, legs, or feet to tune the body section further
          v-col
            v-img(src='/day6-workflow/tune-body-section.png' max-width='128')
      v-timeline-item(color="accent" small)
        v-row(class="pt-1")
          v-col Change the&nbsp;
            a.accent--text(@click.prevent="$emit('show-info-tips')") camera/view
            |  for a better perspective
      v-timeline-item(color="accent" small)
        v-row(class="pt-1")
          v-col
            v-btn.mx-4(outlined fab small color='accent')
              v-icon {{mdiHuman}}
            | opens &nbsp;
            a.accent--text(@click.prevent="$emit('show-info-pose')") Character Pose
      v-timeline-item(color="accent" small)
        v-row(class="pt-1")
          v-col
            v-btn.mx-4(outlined fab small color='accent')
              v-icon download
            | downloads the character asset file
      v-timeline-item(color="accent" small)
        v-row(class="pt-1")
          v-col Import the asset file into your favorite game engine or content editor and have a blast. See these&nbsp;
            a.accent--text(href='https://day6-docs.quickytools.com/guides/configure-unity-import.html' target='_blank') instructions
            |  for setting up 1-click integration in Unity.
      v-timeline-item(color="accent" small)
        v-row(class="pt-1")
          v-col What do you think? Share&nbsp;
            a.accent--text(:href="day6Resource.feedbackSurveyUrl" target="_blank") your thoughts
            |  with us on how to speed up your character creation.
</template>

<script>
import { mdiHuman } from '@mdi/js'
import day6Resource from '@/resources/day6'

export default {
  name: 'Day6InfoGenerate',
  data: () => ({
    mdiHuman,
    day6Resource
  })
}
</script>
